module.exports = __webpack_public_path__ + "img/INTERIOR-SWIFT-SPORT-3.e889264c.jpg";